module.exports = __webpack_public_path__ + "static/media/calendar-date-2.96538fad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/calendar-date-2.svg
// module id = 1233
// module chunks = 0